import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { ProfileAction, MatchAction } from "../../store/actions";

import EditProfileBoxLabel from "../../components/label/editprofileboxlabel";
import EditProfileMultipleSelect from "../../components/dropdown/editprofilemultipleselection";
import HeightSlider from "../../components/rangeslider/heightslider";
import PrimaryButton from "../../components/button/primarybutton";

import {
  bodyTypeFemale,
  bodyTypeMale,
  complexion,
  hairColor,
  hairLengthMale,
  hairLengthFemale,
  hairTypeMale,
  hairTypeFemale,
  bloodGroup,
} from "../../utils/arrayitems";

import withDoesntMatter from "../../utils/doesntmatter";
import { handleDoesntMatter } from "../../utils/handledoesntmatter";

import Spacer from "../../components/spacer/spacer";
import Loader from "../../components/loader/loader";

import images from "../../assets";

import TabHeading from "./tabheading";

import "./styles.css";

const BodyPreference = (props) => {
  const dispatch = useDispatch();
  const profileLoading = useSelector((state) => state?.profile?.isLoading);
  const matchLoading = useSelector((state) => state?.matches?.isLoading);
  const profileData = useSelector((state) => state?.profile?.profile);

  const [isDisabled, setDisabled] = useState(false);

  const [state, setState] = useState({
    bodyType: [""],
    heightMin: 142,
    heightMax: 158,
    complexion: [""],
    hairColor: [""],
    hairType: [""],
    hairLength: [""],
    bloodGroup: [""],
  });

  useEffect(() => {
    setState({
      ...state,
      bodyType: profileData?.matchPreference?.bodyType ?? [""],
      heightMin: profileData?.matchPreference?.heightMin ?? 142,
      heightMax: profileData?.matchPreference?.heightMax ?? 158,
      complexion: profileData?.matchPreference?.complexion ?? [""],
      hairColor: profileData?.matchPreference?.hairColor ?? [""],
      hairType: profileData?.matchPreference?.hairType ?? [""],
      hairLength: profileData?.matchPreference?.hairLength ?? [""],
      bloodGroup: profileData?.matchPreference?.bloodGroup ?? [""],
    });
  }, [profileLoading]);

  const handleSubmit = () => {
    setDisabled(true);
    const payload = {
      username: profileData?.username,
      matchPreference: { ...profileData?.matchPreference, ...state },
    };

    dispatch(
      MatchAction.updateMatchPreference(payload, () => {
        setDisabled(false);
        props?.handleTab("educationCareer");
      })
    );
  };

  return (
    <>
      <TabHeading
        image={images.matchPrefBody}
        title="Body Preference"
        subtitle="Tell us a little about your preferences."
      />
      <div className="edit-profile-content">
        {profileLoading || matchLoading ? (
          <Loader />
        ) : (
          <>
            {/* Body Type */}
            <div className="edit-profile-label-container">
              <EditProfileBoxLabel label="Body Type" />
            </div>
            <Spacer height="8px" />
            <EditProfileMultipleSelect
              placeholder="Body Type"
              data={withDoesntMatter(
                profileData?.gender?.toLowerCase() === "male"
                  ? bodyTypeFemale
                  : bodyTypeMale
              )}
              onChange={(e) => handleDoesntMatter(setState, "bodyType", e)}
              value={state.bodyType || ""}
            />

            <Spacer height="12px" />

            {/* Height Range */}
            <div className="edit-profile-label-container">
              <EditProfileBoxLabel label="Height Range" />
            </div>
            <HeightSlider
              onChange={(e) =>
                setState({ ...state, heightMin: e[0], heightMax: e[1] })
              }
              value={[state.heightMin, state.heightMax] || ""}
            />

            <Spacer height="12px" />

            {/* Complexion */}
            <div className="edit-profile-label-container">
              <EditProfileBoxLabel label="Complexion" />
            </div>
            <Spacer height="8px" />
            <EditProfileMultipleSelect
              placeholder="Complexion"
              data={withDoesntMatter(complexion)}
              onChange={(e) => handleDoesntMatter(setState, "complexion", e)}
              value={state.complexion || ""}
            />

            <Spacer height="12px" />

            {/* Hair Color */}
            <div className="edit-profile-label-container">
              <EditProfileBoxLabel label="Hair Color" />
            </div>
            <Spacer height="8px" />
            <EditProfileMultipleSelect
              placeholder="Hair Color"
              data={withDoesntMatter(hairColor)}
              onChange={(e) => handleDoesntMatter(setState, "hairColor", e)}
              value={state.hairColor || ""}
            />

            <Spacer height="12px" />

            {/* Hair Type */}
            <div className="edit-profile-label-container">
              <EditProfileBoxLabel label="Hair Type" />
            </div>
            <Spacer height="8px" />
            <EditProfileMultipleSelect
              placeholder="Hair Type"
              data={withDoesntMatter(
                profileData?.gender === "male" ? hairTypeFemale : hairTypeMale
              )}
              onChange={(e) => handleDoesntMatter(setState, "hairType", e)}
              value={state.hairType || ""}
            />

            <Spacer height="12px" />
            {/* Hair Length */}
            <div className="edit-profile-label-container">
              <EditProfileBoxLabel label="Hair Length" />
            </div>
            <Spacer height="8px" />
            <EditProfileMultipleSelect
              placeholder="Hair Length"
              data={withDoesntMatter(
                profileData?.gender === "male"
                  ? hairLengthFemale
                  : hairLengthMale
              )}
              onChange={(e) => handleDoesntMatter(setState, "hairLength", e)}
              value={state.hairLength || ""}
            />

            <Spacer height="12px" />
            {/* Blood Group */}
            <div className="edit-profile-label-container">
              <EditProfileBoxLabel label="Blood Group" />
            </div>
            <Spacer height="8px" />
            <EditProfileMultipleSelect
              placeholder="Blood Group"
              data={withDoesntMatter(bloodGroup)}
              onChange={(e) => handleDoesntMatter(setState, "bloodGroup", e)}
              value={state.bloodGroup || ""}
            />
          </>
        )}

        <Spacer height="32px" />
        <PrimaryButton
          text="Save & Continue"
          onClick={handleSubmit}
          disabled={isDisabled}
        />
      </div>
    </>
  );
};

export default BodyPreference;
